import { useContentContext } from '../ContentContext';
import { App, Flex, Select } from 'antd';
import notify from '../../../shared/utils/notify';

export function ProjectVersionPicker() {
    const {
        projectId, versionId,
        selectedVersion,
        canFork,
        forkingVersion,
        projects, versions,
        loadingProjects,
        loadingVersions,
        setProjectId, setVersionId,
        forkCurrentVersion,
    } = useContentContext();

    const onFork = async () => {
        try {
            const created = await forkCurrentVersion();
            if (created?.id) {
                notify.success("Создан новый draft от выбранной версии");
            }
        } catch (error) {
            notify.error(error?.message || "Не удалось создать draft-версию");
        }
    };

    return (
        <App>
            <Flex justify="space-between" gap="medium" align="flex-start" wrap="wrap">
                {selectedVersion?.status && (
                    <div className="flex flex-col gap-1">
                        {/* Переводим label в обычный текст и даем ему id */}
                        <span className="eyebrow" id="status-label">Статус</span>

                        {/* Связываем span со статусным текстом через aria-labelledby */}
                        <span
                            className="chip"
                            id="status-header-picker"
                            role="status"
                            aria-labelledby="status-label"
                        >
                            {selectedVersion.status}
                        </span>
                    </div>
                )}


                <Flex flex vertical gap="small">
                    <label className="eyebrow" htmlFor="version-header-picker">Версия</label>
                    <Select
                        id="version-header-picker"
                        value={versionId ?? ""}
                        onChange={setVersionId}
                        placeholder={!projectId ? "Сначала проект" : "Версия"}
                        disabled={!projectId || loadingVersions}
                        className="w-44"
                    >
                        {versions.map(v => (
                            <Select.Option key={v.id} value={v.id}>
                                {v.name ? `${v.name} (${v.status})` : v.status ?? v.id}
                            </Select.Option>
                        ))}
                    </Select>
                </Flex>

                <Flex flex vertical gap="small">
                    <label className="eyebrow" htmlFor="project-header-picker">Проект</label>
                    <Select
                        id="project-header-picker"
                        value={projectId ?? ""}
                        onChange={setProjectId}
                        placeholder={loadingProjects ? "Загрузка…" : "Выберите проект"}
                        disabled={loadingProjects}
                        className="w-48"
                    >
                        {projects.map(p => (
                            <Select.Option key={p.id} value={p.id}>
                                {p.name ?? p.systemName ?? p.id}
                            </Select.Option>
                        ))}
                    </Select>
                </Flex>

                {canFork && (
                    <button
                        type="button"
                        className="btn btn-outline"
                        onClick={onFork}
                        disabled={forkingVersion}
                    >
                        {forkingVersion ? "Создаём draft..." : "Fork в draft"}
                    </button>
                )}
            </Flex>
        </App>
    );
}